import { memo } from "react";
import { Icon } from "semantic-ui-react";
import { UpdatedUserFirebase } from "./MeFormType";

// Components
import ModInReviewContent from "./ModInReviewContent";
import ModMeForm from "./ModMeForm";

// STYLES
import { ICONS } from "./sequence/MeForm";

// Serializers
import BroadcastPostSerializer from "@/issara-sdk/types/BroadcastPostSerializer_apps_PRX";

type ModInReviewProps = {
  open: boolean;
  onClose: () => void;
  onBack: () => void;
  // data
  broadcast?: BroadcastPostSerializer;
  updatedByUserFirebase?: UpdatedUserFirebase;
};

const ModInReview = (props: ModInReviewProps) => (
  <ModMeForm
    open={props.open}
    onClose={props.onBack}
    onConfirm={props.onBack}
    header={
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <label style={{ color: "var(--primary-theme-color)" }}>Warning!!</label>
        <Icon
          color="red"
          name="close"
          style={{ cursor: "pointer" }}
          onClick={props.onClose}
        />
      </div>
    }
    content={
      <ModInReviewContent
        broadcastDetail={props.broadcast}
        updatedByUserFirebase={props.updatedByUserFirebase}
      />
    }
    // config
    isOneButton
    cancelBtnStyle={{
      backgroundColor: "var(--primary-theme-color)",
      color: "white",
    }}
    cancelTitle={
      <div
        style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "4px" }}
      >
        <img src={ICONS.goBack} />
        <label>Go to Broadcast List</label>
      </div>
    }
  />
);

export default memo(ModInReview);